module.exports = __webpack_public_path__ + "static/img/img_min.1166753.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/img_min.jpg
// module id = h/J/
// module chunks = 1